import { useEffect } from "react";
import "@/App.css";
import SmoothScroll from "@/components/site/SmoothScroll";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Manifesto } from "@/components/site/Manifesto";
import { Ecosystem } from "@/components/site/Ecosystem";
import { Philosophy } from "@/components/site/Philosophy";
import { Founder } from "@/components/site/Founder";
import { FinalCTA } from "@/components/site/FinalCTA";
import { Footer } from "@/components/site/Footer";

function App() {
  useEffect(() => {
    document.documentElement.classList.add("dark");
    const block = (e) => e.preventDefault();
    document.addEventListener("contextmenu", block);
    document.addEventListener("dragstart", block);
    document.addEventListener("copy", block);
    return () => {
      document.removeEventListener("contextmenu", block);
      document.removeEventListener("dragstart", block);
      document.removeEventListener("copy", block);
    };
  }, []);

  return (
    <SmoothScroll>
      <div className="App grain bg-[#060607]">
        <Nav />
        <main>
          <Hero />
          <Manifesto />
          <Ecosystem />
          <Philosophy />
          <Founder />
          <FinalCTA />
        </main>
        <Footer />
      </div>
    </SmoothScroll>
  );
}

export default App;
